module.exports = __webpack_public_path__ + "static/media/back.b13428cf.png";